export const SITE = {
  name: "QuInflection Advisory",
  shortName: "QuInflection",
  tagline: "Own Your Turning Point",
  logoUrl: "/logo-full.png",
  email: "karrie@quinflection.com",
  phone: "587-664-0706",
  phoneHref: "tel:+15876640706",
  linkedin: "https://www.linkedin.com/in/karriequinn",
  headshotUrl: "/karrie-headshot.jpg",
  founder: "Karrie Quinn",
  founderRole: "Owner & Founder",
  bookingUrl: "https://calendly.com/karrie-quinflection/30min",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const bookCallHref = SITE.bookingUrl || "/contact";
